import { ProductCard as ProductCardRoot } from "./ProductCard"
import { ProductCardBadge } from "./ProductCardBadge"
import { ProductCardBrandName } from "./ProductCardBrandName"
import { ProductCardButton } from "./ProductCardButton"
import { ProductCardColorSwatch } from "./ProductCardColorSwatch"
import { ProductCardFooter } from "./ProductCardFooter"
import { ProductCardHeader } from "./ProductCardHeader"
import { ProductCardImage } from "./ProductCardImage"
import { ProductCardRating } from "./ProductCardRating"
import { ProductCardRibbon } from "./ProductCardRibbon"
import { ProductCardWishlist } from "./ProductCardWishlist"
import { ProductCardVariationName } from "./ProductCardVariationName"
import { ProductCardProductName } from "./ProductCardProductName"
import { ProductCardBody } from "./ProductCardBody"

export const ProductCard = ProductCardRoot as typeof ProductCardRoot & {
  ColorSwatch: typeof ProductCardColorSwatch
  Header: typeof ProductCardHeader
  Badge: typeof ProductCardBadge
  Ribbon: typeof ProductCardRibbon
  Image: typeof ProductCardImage
  Wishlist: typeof ProductCardWishlist
  Button: typeof ProductCardButton
  Footer: typeof ProductCardFooter
  Rating: typeof ProductCardRating
  BrandName: typeof ProductCardBrandName
  VariationName: typeof ProductCardVariationName
  ProductName: typeof ProductCardProductName
  Body: typeof ProductCardBody
}

ProductCard.ColorSwatch = ProductCardColorSwatch
ProductCard.Header = ProductCardHeader
ProductCard.Badge = ProductCardBadge
ProductCard.Ribbon = ProductCardRibbon
ProductCard.Image = ProductCardImage
ProductCard.Wishlist = ProductCardWishlist
ProductCard.Button = ProductCardButton
ProductCard.Footer = ProductCardFooter
ProductCard.Rating = ProductCardRating
ProductCard.BrandName = ProductCardBrandName
ProductCard.VariationName = ProductCardVariationName
ProductCard.ProductName = ProductCardProductName
ProductCard.Body = ProductCardBody
